import { controlSizes, spaceScale } from "@maeiz/tokens";
import { DocPage, Section, Demo, SpecTable } from "../../components/DocChrome";

export function SpacingPage() {
    return (
        <DocPage
            title="Spacing & Sizing"
            description="4px-based scale. Avoid arbitrary one-off margins."
        >
            <Section title="Space scale">
                <Demo>
                    <div className="space-y-2">
                        {(["1", "2", "3", "4", "5", "6", "8", "10", "12"] as const).map((k) => (
                            <div key={k} className="flex items-center gap-3">
                                <span className="w-10 font-mono text-xs text-neutral-secondary">
                                    {k}
                                </span>
                                <span
                                    className="h-3 rounded-sm bg-primary"
                                    style={{ width: spaceScale[k] }}
                                />
                                <span className="font-mono text-xs">{spaceScale[k]}</span>
                            </div>
                        ))}
                    </div>
                </Demo>
            </Section>
            <Section title="Control sizes">
                <SpecTable
                    rows={(Object.keys(controlSizes) as Array<keyof typeof controlSizes>).map(
                        (k) => [
                            k,
                            `h ${controlSizes[k].height} · px ${controlSizes[k].paddingX} · ${controlSizes[k].fontSize}`,
                        ]
                    )}
                />
            </Section>
            <Section title="Usage">
                <ul className="list-disc space-y-1 ps-5">
                    <li>Page sections: `space-y-6` / `gap-6`</li>
                    <li>Card internal: `p-4` sm, `p-6` md+</li>
                    <li>Form fields: `gap-4` between fields, `gap-1.5` label→control</li>
                    <li>Icon + text: `gap-2`</li>
                </ul>
            </Section>
        </DocPage>
    );
}
